import { SxProps, Typography } from "@mui/material";
import { useMemo } from "react";
import { OrderStatusType } from "../../enums";
export type OrderStatusLabelProps = {
  label?: string;
  status?: OrderStatusType;
  sx?: SxProps;
};

export const orderStatusColor = (status?: OrderStatusType) => {
  switch (status) {
    case OrderStatusType.Failed:
    case OrderStatusType.Canceled:
      return "error.main";
    case OrderStatusType.Scheduled:
      return "info.main";
    case OrderStatusType.Delivered:
    case OrderStatusType.PartiallyDelivered:
      return "success.main";
    default:
      return "warning.main";
  }
};

export const OrderStatusLabel = ({ label, status = OrderStatusType.Processing, ...others }: OrderStatusLabelProps) => {
  const color = useMemo(() => {
    return orderStatusColor(status);
  }, [status]);
  return (
    <Typography color={color} {...others}>
      {label}
    </Typography>
  );
};
export default OrderStatusLabel;
